import {
  GET_PARAMETERS,
  CREATE_QUERY_PARAM,
  UPDATE_QUERY_PARAM,
  GET_REFERENCES,
  DELETE_PARAMETER,
  GET_USER_VISIBLE_COLUMNS
} from './actionTypes';
import { getActionStatusName } from '@/store/helpers';

export const getParametersStatus = state => state.status[getActionStatusName(GET_PARAMETERS)] || {};
export const createQueryParamStatus = state => state.status[getActionStatusName(CREATE_QUERY_PARAM)] || {};
export const updateQueryParamStatus = state => state.status[getActionStatusName(UPDATE_QUERY_PARAM)] || {};
export const getReferencesStatus = state => state.status[getActionStatusName(GET_REFERENCES)] || {};
export const deleteParameterStatus = state => state.status[getActionStatusName(DELETE_PARAMETER)] || {};
export const getUserVisibleColumnsStatus = state => state.status[getActionStatusName(GET_USER_VISIBLE_COLUMNS)] || {};
